import { render, staticRenderFns } from "./DirectPlacementPaymentDialog.vue?vue&type=template&id=46fc3095"
import script from "./DirectPlacementPaymentDialog.vue?vue&type=script&lang=js"
export * from "./DirectPlacementPaymentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports